import { ErrorMessage } from "formik";
import React, { useState, useEffect, useCallback, useReducer } from "react";
import ReactFancyBox from "react-fancybox";
import { OverlayTrigger, Popover, Row, Tooltip } from "react-bootstrap";
import Cropper from "react-easy-crop";
import { getCroppedImg } from "../../../helpers/canvasUtils";

import axios from "../../../config/axios";
import { Store as toast } from "react-notifications-component";
import { toastNotification } from "../../../config/toastNotification";
import {
  updateReducer,
  updateInitialState,
} from "../../../reducers/module/updateReducer";
const CMSFormImageWithCrop = (props) => {
  const {
    name,
    label,
    form,
    info,
    aspect,
    outputSize,
    required,
    reLoad,
    moduleName,
    id,
    helpMessage,
  } = props;

  let initialImageURL = form.values[name]
    ? process.env.REACT_APP_BACKEND_URL + "public/" + form.values[name]
    : null;

  const [removeState, removeDispatch] = useReducer(
    updateReducer,
    updateInitialState
  );
  const [image, setImage] = useState(null);
  const [imageURL, setImageURL] = useState(initialImageURL);

  const [showCropping, setShowCropping] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    //console.log(croppedArea, croppedAreaPixels)
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);
  const [fileName, setFileName] = useState("Choose file");
  useEffect(() => {
    if (!image || !image.name) return;
    setImageURL(URL.createObjectURL(image));
    setFileName(image.name);
  }, [image]);
  // useEffect(() => {
  //     console.log(image)
  //     if (!image || !image.name) return;
  //     setImageURL(URL.createObjectURL(image))

  // }, [image])
  const onRemoveFile = async (data) => {
    removeDispatch({
      type: "FORM_SUBMISSION_REQUEST",
    });

    try {
      const res = await axios.post(`general/remove-file`, data); //
      removeDispatch({
        type: "FORM_SUBMISSION_SUCCESS",
        payload: res.data,
      });
      reLoad();
      clearImage();
      toast.addNotification({
        ...toastNotification,
        title: "Success!",
        message: `File removed successfully.`,
        type: "success",
      });
    } catch (error) {
      //console.log(error.message);
      clearImage();
      const status = error.response ? error.response.status : 500;
      const errorMessage =
        status === 400 ? error.response.data.errorMessage : error.message;

      removeDispatch({
        type: "FORM_SUBMISSION_FAILURE",
        payload: errorMessage,
      });
      setTimeout(() => {
        removeDispatch({
          type: "FORM_INITIAL_STATE",
        });
      }, 5000);
    }
  };
  const onImageChange = (e) => {
    if (e.target && e.target.files[0]) {
      //form.handleChange(e)
      setImage(e.target.files[0]);
      form.setFieldValue(name, e.target.files[0]);
    } else {
      //form.handleChange(e)
      clearImage();
    }
  };

  const clearImage = async () => {
    setImage(null);
    setImageURL(null);
    //setFileName(null)

    await form.setFieldValue(name, "", true);
    form.setFieldTouched(name, true);
  };

  const cropImage = useCallback(async () => {
    try {
      const croppedImage = await getCroppedImg(
        imageURL,
        croppedAreaPixels,
        outputSize,
        form.values[name].type
      );

      setImageURL(croppedImage.fileUrl);
      setShowCropping(false);

      const newImage = new File(
        [croppedImage.blob],
        "croppedImage." + (image.type === "image/png" ? "png" : "jpeg"),
        { type: image.type },
        { fileUrl: croppedImage.fileUrl }
      );
      form.setFieldValue(name, newImage);
    } catch (e) {
      console.error(e);
    }
  }, [imageURL, croppedAreaPixels]);

  return (
    <>
      {/* {console.log("Touched", form.touched[name])} */}
      {/* {console.log(form.values[name].type,"1111111111")} */}
      <div className="form-group ">
        {label !== "" && (
          <>
            {required === true ? (
              <OverlayTrigger
                key={`tooltip-${name}`}
                placement="right"
                overlay={
                  <Tooltip id={`tooltip-right`}>Required field.</Tooltip>
                }
              >
                <label
                  htmlFor={name}
                  className={`required ' ${
                    form.touched[name] && form.errors[name]
                      ? "is-invalidText"
                      : ""
                  }`}
                >
                  {" "}
                  {label}{" "}
                  {info ? <i className="smallInfo">( {info} )</i> : null}
                </label>
              </OverlayTrigger>
            ) : (
              <label
                htmlFor={name}
                className={` ${
                  form.touched[name] && form.errors[name]
                    ? "is-invalidText"
                    : ""
                }`}
              >
                {" "}
                {label} {info ? <i className="smallInfo">( {info} )</i> : null}
              </label>
            )}
          </>
        )}
        {helpMessage && helpMessage.message && (
          <OverlayTrigger
            trigger="hover"
            key={`info-popup-${name}`}
            placement="right"
            overlay={
              <Popover id={`popover-positioned-${name}`}>
                {helpMessage.heading && (
                  <Popover.Header as="h3">{helpMessage.heading}</Popover.Header>
                )}
                <Popover.Body>{helpMessage.message}</Popover.Body>
              </Popover>
            }
          >
            <i className="fa fa-info-circle ml-2 pb-2 infoIcon"></i>
          </OverlayTrigger>
        )}
        {/* <label htmlFor={name} className={` ${(form.touched[name] && form.errors[name]) ? "is-invalidText required" : "required"}`}> {label}</label> */}
        {showCropping ? (
          <Row>
            <div className="croppingArea">
              <Cropper
                image={imageURL}
                crop={crop}
                zoom={zoom}
                aspect={aspect}
                //restrictPosition={false}
                onCropChange={setCrop}
                onCropComplete={onCropComplete}
                onZoomChange={setZoom}
              />
            </div>
            <div className="imageActionsContainerBack">
              <div className="imageAction">
                <i
                  className=" fas fa-arrow-left"
                  onClick={() => setShowCropping(false)}
                />
              </div>
              <div className="imageAction ">
                <i className=" fas fa-crop " onClick={() => cropImage()} />
              </div>
            </div>
          </Row>
        ) : (
          <>
            <div
              className={`input-group ${
                form.touched[name] && form.errors[name] ? "is-invalid" : ""
              }`}
            >
              <div className="input-group-prepend">
                <span
                  className="input-group-text"
                  id={`${
                    form.touched[name] && form.errors[name]
                      ? "is-invalidInputGroupFileAddon01"
                      : "inputGroupFileAddon01"
                  }`}
                >
                  Upload
                </span>
              </div>
              <div className="custom-file">
                <input
                  type="file"
                  className="custom-file-input"
                  id="image"
                  aria-describedby="inputGroupFileAddon01"
                  accept="image/*"
                  onChange={(e) => onImageChange(e)}
                  onBlur={form.handleBlur}
                />
                <label
                  className={` ${
                    form.touched[name] && form.errors[name]
                      ? "is-invalid custom-file-label"
                      : "custom-file-label"
                  }`}
                  htmlFor="inputGroupFile01"
                >
                  {/* {(image && image.name) ? image.name : "choose file"} */}
                  {form.values[name] && form.values[name].name
                    ? form.values[name].name
                    : form.values[name]}
                </label>
              </div>
            </div>
            {form.touched[name] && form.errors[name] && (
              <span id={`${name}-error"`} className="error invalid-feedback">
                <ErrorMessage name={name} />
              </span>
            )}
          </>
        )}
      </div>

      {imageURL && !showCropping && (
        <Row className="px-2 mb-2">
          <div className="formImagePreview ">
            {/* <Image src={imageURL} thumbnail /> */}
            <ReactFancyBox thumbnail={imageURL} image={imageURL} />
          </div>

          <div className="imageActionsContainer">
            <div className="imageAction">
              <i
                className=" fas fa-times"
                onClick={() =>
                  onRemoveFile({
                    moduleName: moduleName,
                    fieldName: name,
                    id: id,
                  })
                }
              />
            </div>
            <div className="imageAction">
              <i
                className=" fas fa-crop"
                onClick={() => setShowCropping(true)}
              />
            </div>
          </div>
        </Row>
      )}
    </>
  );
};

export default CMSFormImageWithCrop;
